import { correlationId } from './requestGenerators.esm.js';
import { MSHeaders } from './constants.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
var config = {
    baseURL: '',
    timeout: 10000,
    headers: (_obj = {}, _define_property(_obj, MSHeaders.CORRELATION_ID, correlationId()), _define_property(_obj, MSHeaders.CLIENT_NAME, 'Agoras'), _define_property(_obj, MSHeaders.APP, 'Agoras'), _obj)
};

export { config };
